import Legal from "../Legal";

export default function Privacy() {
  return (
    <Legal
      title="Politique de Confidentialité"
      subtitle="Dernière mise à jour : Février 2026 — Conforme RGPD"
    >
      <h2>1. Responsable du traitement</h2>
      <p>
        Le responsable du traitement des données personnelles collectées sur le
        site <strong>nordstellatech.fr</strong> est :
      </p>
      <ul>
        <li>Nord Stella Tech — Lacina DIOMANDE (Auto-entrepreneur)</li>
        <li>SIRET : 104 860 663 00012</li>
        <li>Adresse : 1 CHE d'Acces aux Abbesses, 93220 Gagny, FRANCE</li>
        <li>Email : nordstellatech@gmail.com</li>
      </ul>

      <h2>2. Données collectées</h2>
      <p>Nous collectons uniquement les données strictement nécessaires :</p>
      <ul>
        <li><strong>Inscription / compte</strong> : nom, email, mot de passe (chiffré).</li>
        <li><strong>Commandes</strong> : adresse de livraison, email, articles commandés, montants.</li>
        <li><strong>Paiement</strong> : traité par Stripe — aucune donnée bancaire n'est stockée par Nord Stella.</li>
        <li><strong>Contact / Newsletter</strong> : email et message.</li>
        <li><strong>Cookies techniques</strong> : session, panier, préférences.</li>
      </ul>

      <h2>3. Finalités du traitement</h2>
      <ul>
        <li>Exécution du contrat de vente (commande, livraison, SAV).</li>
        <li>Gestion de votre compte client.</li>
        <li>Réponse à vos demandes via le formulaire de contact.</li>
        <li>Envoi de la newsletter (avec votre consentement explicite).</li>
        <li>Obligations comptables et fiscales légales.</li>
      </ul>

      <h2>4. Base légale</h2>
      <p>
        Les traitements sont fondés sur l'exécution du contrat (commandes), le
        consentement (newsletter), l'intérêt légitime (sécurité, prévention
        fraude), et les obligations légales (comptabilité).
      </p>

      <h2>5. Durée de conservation</h2>
      <ul>
        <li>Compte client : pendant la durée d'activité, puis 3 ans après la dernière connexion.</li>
        <li>Données de commande : 10 ans (obligation comptable).</li>
        <li>Newsletter : jusqu'au désabonnement.</li>
        <li>Messages de contact : 3 ans après le dernier échange.</li>
      </ul>

      <h2>6. Destinataires</h2>
      <p>
        Vos données ne sont jamais vendues à des tiers. Elles sont
        transmises uniquement à nos sous-traitants strictement nécessaires
        (Stripe pour le paiement, hébergeur cloud), tous engagés
        contractuellement au respect du RGPD.
      </p>

      <h2>7. Vos droits</h2>
      <p>
        Conformément au RGPD, vous disposez des droits suivants :
      </p>
      <ul>
        <li><strong>Droit d'accès</strong> à vos données.</li>
        <li><strong>Droit de rectification</strong> de données inexactes.</li>
        <li><strong>Droit à l'effacement</strong> ("droit à l'oubli").</li>
        <li><strong>Droit à la limitation</strong> du traitement.</li>
        <li><strong>Droit à la portabilité</strong> de vos données.</li>
        <li><strong>Droit d'opposition</strong> au traitement.</li>
        <li><strong>Droit de retirer votre consentement</strong> à tout moment.</li>
      </ul>
      <p>
        Pour exercer ces droits, écrivez à{" "}
        <a href="mailto:nordstellatech@gmail.com">nordstellatech@gmail.com</a>.
        Réponse sous 30 jours.
      </p>

      <h2>8. Réclamation</h2>
      <p>
        Vous pouvez introduire une réclamation auprès de la{" "}
        <a href="https://www.cnil.fr" target="_blank" rel="noreferrer">CNIL</a>{" "}
        (Commission Nationale de l'Informatique et des Libertés) si vous
        estimez que vos droits ne sont pas respectés.
      </p>

      <h2>9. Sécurité</h2>
      <p>
        Nous mettons en œuvre toutes les mesures techniques et
        organisationnelles raisonnables pour protéger vos données : chiffrement
        des mots de passe (bcrypt), HTTPS/TLS, restriction d'accès, sauvegardes
        régulières.
      </p>

      <h2>10. Cookies</h2>
      <p>
        Le site utilise uniquement des cookies strictement nécessaires
        (authentification, panier). Aucun cookie publicitaire ou de tracking
        tiers n'est déposé sans votre consentement préalable.
      </p>
    </Legal>
  );
}
